import React from 'react';
import {
  IconAddressBook,
  IconAdjustments,
  IconAlertTriangle,
  IconArrowLeft,
  IconBriefcase2,
  IconBuildingSkyscraper,
  IconCash,
  IconCircleCheck,
  IconCirclePlus,
  IconClipboardCheck,
  IconClockCog,
  IconFileText,
  IconFolderOpen,
  IconHeartbeat,
  IconKey,
  IconListDetails,
  IconLocationShare,
  IconPencilDollar,
  IconPlugConnected,
  IconPremiumRights,
  IconShieldSearch,
  IconSitemap,
  IconUserDollar,
  IconUsers,
  IconUsersGroup,
  IconUsersPlus,
} from '@tabler/icons-react';
import { FireIcon } from 'src/design/atoms/FireIcon';
import { INavigationMenu } from 'src/app/navigation/navigationTypes';

export const settingsItems: INavigationMenu = {
  items: [
    {
      id: 'back-settings',
      type: 'group',
      children: [
        {
          id: 'back',
          allowAll: true,
          title: 'Back to Dashboard',
          type: 'item',
          url: '/ctc',
          icon: <IconArrowLeft size={22} />,
          keepDrawerOpen: true,
        },
      ],
    },
    {
      id: 'group-settings',
      title: 'Admin Settings',
      type: 'group',
      children: [
        {
          id: 'admin_users',
          requiredScopes: ['settings_all', 'settings_user'],

          title: 'Users',
          type: 'item',
          url: '/settings/users',
          icon: <IconUsersPlus size={22} />,
        },
        {
          id: 'admin_roles',
          title: 'Roles',
          requiredScopes: ['settings_all', 'settings_roles'],
          type: 'item',
          url: '/settings/roles',
          icon: <IconShieldSearch size={22} />,
        },
        {
          id: 'admin_offices',
          title: 'Offices',
          type: 'item',
          url: '/settings/offices',
          requiredScopes: ['settings_all', 'settings_offices'],
          icon: <IconBuildingSkyscraper size={22} />,
        },
        {
          id: 'admin_cost_codes',
          title: 'Cost Codes',
          type: 'item',
          url: '/settings/cost-codes',
          requiredScopes: ['settings_all', 'settings_cost_codes'],
          icon: <IconPencilDollar size={22} />,
        },
        {
          id: 'admin_customers',
          title: 'Customers',
          requiredScopes: ['settings_all', 'settings_customers'],
          type: 'item',
          url: '/settings/customers',
          icon: <IconUsers size={22} />,
        },
        {
          id: 'admin_contacts',
          title: 'Contacts',
          requiredScopes: ['settings_all', 'settings_contacts'],
          type: 'item',
          url: '/settings/contacts',
          icon: <IconAddressBook size={22} />,
        },
        {
          id: 'admin_pay_rates',
          title: 'Pay & Rates',
          type: 'collapse',
          icon: <IconCash size={22} />,

          requiredScopes: [
            'settings_all',
            'settings_rates',
            'settings_classifications',
            'settings_pay_codes',
          ],
          children: [
            {
              id: 'admin_classifications',
              title: 'Classifications',
              type: 'item',
              url: '/settings/classifications',
              requiredScopes: ['settings_all', 'settings_classifications'],
              icon: <IconBriefcase2 size={22} />,
            },
            {
              id: 'admin_pay_codes',
              title: 'Pay Codes',
              type: 'item',
              url: '/settings/pay-codes',
              requiredScopes: ['settings_all', 'settings_pay_codes'],
              icon: <IconUserDollar size={22} />,
            },
            {
              id: 'admin_rates',
              title: 'Rates',
              type: 'item',
              url: '/settings/rates',
              requiredScopes: ['settings_all', 'settings_rates'],
              icon: <IconPremiumRights size={22} />,
            },
          ],
        },
        {
          id: 'admin_milestones',
          title: 'Milestones',
          type: 'item',
          requiredScopes: ['settings_all', 'settings_milestones'],
          url: '/settings/milestones',
          icon: <IconCircleCheck size={22} />,
        },
        {
          id: 'admin_changes',
          title: 'Changes',
          type: 'item',
          requiredScopes: ['settings_all', 'settings_changes'],
          url: '/settings/changes',
          icon: <IconAdjustments size={22} />,
        },
        {
          id: 'admin_change_types',
          title: 'Change Types',
          type: 'item',
          requiredScopes: ['settings_all', 'settings_changes'],
          url: '/settings/change-types',
          icon: <IconListDetails size={22} />,
        },
        {
          id: 'admin_documents',
          title: 'Documents',
          type: 'item',
          requiredScopes: ['settings_all', 'settings_documents'],
          url: '/settings/documents',
          icon: <IconFolderOpen size={22} />,
        },
        {
          id: 'admin_user_history',
          title: 'User Login History',
          type: 'item',
          requiredScopes: ['settings_all', 'settings_login_history'],
          url: '/settings/user_history',
          icon: <IconLocationShare size={22} />,
        },
      ],
    },
    {
      id: 'advanced-settings',
      title: 'Advanced',
      type: 'group',
      icon: <IconAlertTriangle size={22} />,
      children: [
        {
          id: 'admin_workflows',
          title: 'Workflows',
          type: 'item',
          url: '/settings/workflows',
          requiredScopes: ['settings_all', 'settings_workflows'],
          icon: <IconSitemap size={22} />,
        },
        {
          id: 'admin_api_connections',
          title: 'API Connections',
          type: 'item',
          requiredScopes: ['sys_admin'],
          url: '/settings/api-connections',
          icon: <IconKey size={22} />,
        },
        {
          id: 'admin_proact',
          title: 'Proact',
          type: 'item',
          requiredScopes: ['sys_admin'],
          url: '/settings/proact',
          icon: <IconClipboardCheck size={22} />,
        },
        {
          id: 'admin_scim_integrations',
          title: 'SCIM Integrations',
          type: 'item',
          requiredScopes: ['sys_admin'],
          url: '/settings/scim-integrations',
          icon: <IconPlugConnected size={22} />,
        },
        {
          id: 'admin_azure_group_sync',
          title: 'Azure Group Sync',
          type: 'item',
          requiredScopes: ['sys_admin'],
          url: '/settings/azure-group-sync',
          icon: <IconUsersGroup size={22} />,
        },
        {
          id: 'admin_background_jobs',
          title: 'Background Jobs',
          type: 'item',
          requiredScopes: ['sys_admin'],
          url: '/settings/background-jobs',
          icon: <IconClockCog size={22} />,
        },
        {
          id: 'admin_healthcheck',
          title: 'Healthcheck',
          type: 'item',
          requiredScopes: ['sys_admin'],
          url: '/settings/healthcheck',
          icon: <IconHeartbeat size={22} />,
        },
        {
          id: 'admin_app_logs',
          title: 'App Logs',
          type: 'item',
          requiredScopes: ['sys_admin'],
          url: '/settings/app-logs',
          icon: <IconFileText size={22} />,
        },
        {
          id: 'admin_ai_assistant',
          title: 'F.I.R.E.',
          type: 'item',
          requiredScopes: ['sys_admin'],
          url: '/settings/ai-assistant',
          icon: <FireIcon size={22} />,
        },
      ],
    },
    {
      id: 'create-job-settings',

      type: 'group',
      children: [
        {
          requiredScopes: ['ctc_create_job'],
          id: 'create',
          title: 'Create Job',
          type: 'item',
          url: '/ctc',
          isCreateJob: true,
          icon: <IconCirclePlus size={22} />,
        },
      ],
    },
  ],
};
